
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IActionCriteria, InvoiceApprovalContext, UpdateDocumentsParams } from "@tylertech/tyler-api-types";

/**
 * InvoiceService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class InvoiceService<T = unknown> {
    constructor(private readonly $apiService: ApiService) { }
    
    Initialize(): Promise<T> {
        return this.$apiService.sendAuth("IInvoiceService/Initialize");
    }
    PerformAction(pCriteria: IActionCriteria): Promise<any> {
        return this.$apiService.sendAuth("IInvoiceService/PerformAction", pCriteria);
    }
    UpdateApprovalsForInvoice(pContext: InvoiceApprovalContext): Promise<boolean> {
        return this.$apiService.sendAuth("IInvoiceService/UpdateApprovalsForInvoice", pContext);
    }
    UpdateDocuments(parameters: UpdateDocumentsParams): Promise<void> {
        return this.$apiService.sendAuth("IInvoiceService/UpdateDocuments", parameters);
    }
}
